import React from "react"
import PropTypes from "prop-types"

const styleSheet = theme => ({
  root: {
    padding: [theme.spacing.unit * 3, 0, theme.spacing.unit * 3],
    width: "100%",
    color: theme.palette.text.secondary,
    position: "absolute",
    top: "100%",

    [theme.breakpoints.down("xs")]: {
      padding: [theme.spacing.unit * 2, theme.spacing.unit * 3],
      position: "static",
      marginTop: "auto",
    },
  },
})

function StaticDialogFootnote({
  children,
  classes,
  className: classNameProp,
  scrolled,

  ...otherProps
}) {
  const className = classnames(classes.root, classNameProp)

  return (
    <div className={className} {...otherProps}>
      {children}
    </div>
  )
}

StaticDialogFootnote.propTypes = {
  scrolled: PropTypes.bool,
}

import withStyles from "@material-ui/core/styles/withStyles"
import classnames from "classnames"

export default withStyles(styleSheet)(StaticDialogFootnote)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-StaticDialog/StaticDialogFootnote.js